import { createAction, props } from '@ngrx/store';
import { NotificationQueryParams } from '../../services/notification.service';
import { NotificationPreferenceUpdate } from '../../models/Notifications';

export enum NotificationsUiActionTypes {
  GetNotifications = '[Notifications UI] Get Notifications',
  GetNotificationPreferences = '[Notifications UI] Get Notification Preferences',
  UpdateNotificationPreferences = '[Notifications UI] Update Notification Preferences',
  MarkNotificationsRead = '[Notifications UI] Mark Notifications Read',
}

export const GetNotifications = createAction(
  NotificationsUiActionTypes.GetNotifications,
  props<{ params?: NotificationQueryParams }>()
);

export const GetNotificationPreferences = createAction(NotificationsUiActionTypes.GetNotificationPreferences);

export const UpdateNotificationPreferences = createAction(
  NotificationsUiActionTypes.UpdateNotificationPreferences,
  props<{ preferences: NotificationPreferenceUpdate[] }>()
);

export const MarkNotificationsRead = createAction(
  NotificationsUiActionTypes.MarkNotificationsRead,
  props<{ ids: number[] }>()
);
